<template>
    <div>
        <div class="row">
            <div class="col-md-8">
                <p class="text-justify">Wissen Sie nicht welche Weiterbildung Sie im Bereich der Wirtschaftsinformatik machen wollen?</p>
                <p class="text-justify">Sind Sie unsicher was zu Ihrem beruflichen Profil passt oder in welche Richtung Sie sich entwickeln möchten?</p>
                <p class="text-justify"><b>Mit diesem Beratungstool können Sie Ihre Fragen beantworten!</b> Finden Sie heraus welcher MAS-Kurs zu Ihnen passt und welche CAS-Kurse für Sie empfohlen werden.</p>
            </div>
            <div class="col-md-4">
                <img id="zhaw-overview-img" class="img-fluid" alt="ZHAW MAS für Wirtschaftsinformatik" src="../assets/Uebersicht.png">
            </div>
        </div>

        <br>

        <div class="text-center">
            <b-button id="zhaw-acceptance-criterias" class="zhaw-start-buttons" block pill size="lg" to="/zulassungskriterien">Zulassungskriterien überprüfen</b-button>
            <b-button id="zhaw-start-consultation" class="zhaw-start-buttons" @click="increaseProgress" block pill size="lg" to="/initiale-angaben" variant="primary">Beratung starten!</b-button>
        </div>
    </div>
</template>

<script>
    import {herokuApi, mockApi, isUsingMockData} from "../api/axiosConfig";
    import sharedStore from "../state-management/store";

    export default {
        name: "ConsultationStart",
        data() {
            return {
                sessionToken: null,
                axiosErrors: [],
                axiosHasError: false,
                axiosLoading: true,
                isIE11: sharedStore.state.isIE11
            }
        },
        methods: {
            async createSession() {
                if (!isUsingMockData) {
                    await herokuApi
                        .get('/recommender/createSession', {
                            /* Sets an initial value for the session management.
                            Will then be overwritten by the code in the following then(). */
                            headers: { 're-session-token': 0 }
                        })
                        .then(response => {
                            /* Sets for all following requests the same session token.
                            Will be overwritten as soon, as this createSession() method will be called again. */
                            this.sessionToken = response.data;
                            herokuApi.defaults.headers.common['re-session-token'] = this.sessionToken;
                        })
                        .catch(error => {
                            this.axiosErrors.push(error);
                            this.axiosHasError = true
                        })
                        .finally(() => this.axiosLoading = false)
                } else {
                    await mockApi
                        .get('/createSession.json', {
                            headers: { 're-session-token': 0 }
                        })
                        .then(response => {
                            this.sessionToken = response.data;
                            herokuApi.defaults.headers.common['re-session-token'] = this.sessionToken;
                        })
                        .catch(error => {
                            this.axiosErrors.push(error);
                            this.axiosHasError = true
                        })
                        .finally(() => this.axiosLoading = false)
                }
            },
            increaseProgress() {
                sharedStore.increaseProgressValue(10);
            }
        },
        mounted() {
            sharedStore.setIsInitSessionFinished(null);
            sharedStore.setTableNumber(1);
            sharedStore.setProgressValue(10);
            sharedStore.resetInitialForm();
            this.createSession()
        }
    }
</script>

<style scoped>
    .zhaw-start-buttons {
        padding: 15px;
        margin-bottom: 10px !important;
    }

    #zhaw-overview-img {
    }
</style>